import reportWebVitals from "./reportWebVitals";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { lazy } from "react";

import "./DisableLogs";
import App from "./App";
const JazzCashApp = lazy(() => import("../src/JazzCash/index"));
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const ResolveApp = () => {
  const path = window.location.pathname
  if( path.startsWith("/jc") || path.startsWith("/landingjazzcash"))
  {
    return <JazzCashApp />
  }
  return <App />
}
root.render(
  <BrowserRouter>
    <ResolveApp />
  </BrowserRouter>
);

reportWebVitals();
